import { formatUserOperationRequest, getUserOperationError, } from 'viem/account-abstraction';
/**
 * Same as viem's sendUserOperation, but without the call to prepareUserOperation because our's is already prepared
 * @param account
 * @param parameters
 * @returns
 */
export async function eth_sendUserOperation(client, parameters) {
    const account = client.account;
    if (!account) {
        throw new Error('Account is undefined');
    }
    const signature = await account.signUserOperation(parameters);
    const rpcParameters = formatUserOperationRequest({
        ...parameters,
        signature,
    });
    const entryPointAddress = account.entryPoint.address;
    try {
        const response = await client.request({
            method: 'eth_sendUserOperation',
            params: [rpcParameters, entryPointAddress],
        }, { retryCount: 0 });
        return response;
    }
    catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        const calls = parameters.calls;
        // eslint-disable-next-line @typescript-eslint/only-throw-error
        throw getUserOperationError(error, {
            ...parameters,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            ...(calls ? { calls } : {}),
            signature,
        });
    }
}
